type SeedValue = string | number | (string | number | null)[] | null | undefined

interface Seed {
  [key: string]: SeedValue
}

const convertSeedValToQueryVal = (key: string, seedVal: SeedValue): string => {
  if (Array.isArray(seedVal) && seedVal.length === 0) {
    return ""
  } else if (Array.isArray(seedVal)) {
    return seedVal
      .filter((v) => !!v)
      .map((v) => `${key}=${v}`)
      .join("&")
  } else {
    return seedVal ? `${key}=${seedVal}` : ""
  }
}

const toQuery = (seed: Seed): string => {
  const queryParams: string[] = []
  Object.entries(seed).forEach(([key, value]) => {
    const params = convertSeedValToQueryVal(key, value)
    if (params) {
      queryParams.push(params)
    }
  })

  return queryParams.length === 0 ? "" : `?${queryParams.join("&")}`
}

export const queryParameterUiLogics = () => ({
  updateURLQuery: (querySeed: Seed) => {
    const path = location.pathname
    const query = toQuery(querySeed)
    history.replaceState("", "", `${path}${query}`)
    history.pushState("", "", `${path}${query}`)
  },
})
